export default "__VITE_ASSET__CHtNc3EM__"